import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TopLevelDomainVO} from '../../../generate/TopLevelDomainVO';
import {ContactVO} from '../../../generate/ContactVO';
import {ChangeVO} from '../../../generate/ChangeVO';


@Component({
  selector: 'contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss']
})
export class ContactInfoComponent implements OnInit {

  @ViewChild('contactInfoView') contactInfoView: ElementRef<HTMLElement>;
  @ViewChild('contactInfoEdit') contactInfoEdit: ElementRef<HTMLElement>;

  @Input()
  contactVO: ContactVO;
  @Input()
  type: string;
  @Input()
  domain: TopLevelDomainVO;
  @Input()
  lastchange: string;
  @Input()
  change: ChangeVO;
  @Input()
  pendingRequestChangeID: string;
  @Output()
  modifiedTLDOutput = new EventEmitter<TopLevelDomainVO>();

  @Input()
  viewMode: boolean;
  editmode: boolean;

  @Output()
  contactInfoEditModeEnabled = new EventEmitter<boolean>();
  title: string;


  constructor() {
  }

  ngOnInit() {
    switch (this.type) {
      case 'AC':
        this.title = 'Administrative Contact';
        break;
      case 'TC':
        this.title = 'Technical Contact';
        break;
    }
  }

  edit(val) {
    this.editmode = val;
    this.contactInfoEditModeEnabled.emit(val);
    if (val) {
      this.contactInfoEdit.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    } else {
      setTimeout(() => {
        this.contactInfoView.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        });
      }, 1);
    }
  }

  cancel(val) {
    this.edit(false);
  }

  contactOutPut(contactVO: ContactVO) {
    this.modifiedTLDOutput.emit(this.domain);
    this.edit(false);
  }

}
